import { createFileRoute, redirect } from '@tanstack/react-router';

/** Old email links only redirect to preview. Acceptance always requires POST. */
export const Route = createFileRoute('/invites/$token_/accept')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/invites/$token', params: { token: params.token } });
  },
});
